export default __webpack_public_path__ + "static/media/char_body_prem_007.a9ea2126.png";